module.exports = __webpack_public_path__ + "static/img/dian2.fa0bc20c.png";